import React from 'react';
import { Flex, Button } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { clrs } from "../../../constants/colors";
import MyText from "../../../components/UI/Text/MyText";
import IntlMessage from "../../../components/IntlMessage/IntlMessage";
import { useNavigate } from "react-router-dom";
import img2 from '../../Team/images/2.jpg';
import img1 from '../../Team/images/1.png';
import img14 from '../../Team/images/14.jpeg';
import img5 from '../../Team/images/5.jpg';
import img10 from '../../Team/images/10.jpg';
import img3 from '../../Team/images/3.jpg';
import img29 from '../../Team/images/29.png';
import img27 from '../../Team/images/27.jpg';

const CARD_WIDTH = 190;
const CARD_IMG_HEIGHT = 210;
const CARD_TEXT_HEIGHT = 110;

const previewMembers = [
    { id: 1, name: 'Нефтисов А.В.',     role: 'Научный руководитель, старший научный сотрудник', image: img2 },
    { id: 2, name: 'Белошицкий А.А.',    role: 'Старший научный сотрудник',                       image: img1 },
    { id: 3, name: 'Казамбаев И.М.',     role: 'Научный сотрудник',                               image: img14 },
    { id: 4, name: 'Токсанов С.Н.',      role: 'Научный сотрудник',                               image: img5 },
    { id: 5, name: 'Абжанова Д.Е.',     role: 'Разработчик базы данных',                         image: img10 },
    { id: 6, name: 'Кучанский А.',       role: 'Старший научный сотрудник',                       image: img3 },
    { id: 7, name: 'Камбарова Ж.Д.',     role: 'Менеджер проекта',                                image: img29 },
    { id: 8, name: 'Аубакирова А.М.',    role: 'Младший научный сотрудник',                       image: img27 },
];

const PreviewCard = ({ member }) => (
    <Flex
        vertical
        align="center"
        style={{
            width: CARD_WIDTH,
            borderRadius: 14,
            overflow: "hidden",
            background: clrs.white,
            boxShadow: "0 4px 14px rgba(0,0,0,0.07)",
            border: `1px solid ${clrs.whiter2}`,
            flexShrink: 0,
        }}
    >
        <div style={{
            width: "100%",
            height: CARD_IMG_HEIGHT,
            backgroundImage: `url(${member.image})`,
            backgroundSize: "cover",
            backgroundPosition: "center top",
            flexShrink: 0,
        }} />
        <Flex
            vertical
            align="center"
            justify="center"
            gap={6}
            style={{
                padding: "12px 10px",
                width: "100%",
                height: CARD_TEXT_HEIGHT,
            }}
        >
            <MyText strong style={{ fontSize: "0.82rem", color: clrs.textColor, textAlign: "center", lineHeight: 1.3, margin: 0 }}>
                {member.name}
            </MyText>
            <MyText italic style={{ fontSize: "0.74rem", color: clrs.whiterBlacker, textAlign: "center", lineHeight: 1.3, margin: 0 }}>
                {member.role}
            </MyText>
        </Flex>
    </Flex>
);

const TeamSection = () => {
    const navigate = useNavigate();

    return (
        <Flex
            style={{
                width: "100%",
                position: "relative",
                padding: "80px 20px",
                background: clrs.whiter3AquaGeo,
            }}
            align="center"
            justify="center"
            vertical
        >
            <Flex
                gap={48}
                style={{ width: "100%", maxWidth: 1440 }}
                vertical
                align="center"
            >
                {/* Title */}
                <Flex vertical align="center" gap={16} style={{ textAlign: "center" }}>
                    <MyText
                        style={{
                            fontSize: "2.2rem",
                            fontWeight: 900,
                            color: clrs.textColor,
                        }}
                    >
                        <IntlMessage id={'homePage.team'} />
                    </MyText>
                    <MyText
                        style={{
                            fontSize: "1rem",
                            color: clrs.whiterBlacker,
                            maxWidth: 680,
                            lineHeight: 1.6,
                            opacity: 0.9,
                        }}
                    >
                        <IntlMessage id={'homePage.team.description'} />
                    </MyText>
                </Flex>

                {/* Preview cards */}
                <Flex
                    wrap="wrap"
                    gap={20}
                    justify="center"
                    align="flex-start"
                    style={{ width: "100%" }}
                >
                    {previewMembers.map(member => (
                        <PreviewCard key={member.id} member={member} />
                    ))}
                </Flex>

                {/* CTA */}
                <Flex vertical align="center" gap={12}>
                    <MyText style={{ fontSize: "0.95rem", color: clrs.whiterBlacker }}>
                        И ещё 22 участника проекта
                    </MyText>
                    <Button
                        type="primary"
                        size="large"
                        icon={<ArrowRightOutlined />}
                        iconPosition="end"
                        onClick={() => navigate('/team')}
                        style={{
                            borderRadius: 12,
                            height: 48,
                            paddingLeft: 28,
                            paddingRight: 28,
                            fontSize: "1rem",
                            fontWeight: 600,
                            background: clrs.blue,
                            border: "none",
                        }}
                    >
                        Посмотреть полный список
                    </Button>
                </Flex>
            </Flex>
        </Flex>
    );
};

export default TeamSection;
